import {useCallback} from 'react';
import type {CodelistRestrictor} from 'services/codelists';
import {useRestrictedCodelistsContext} from 'services/codelists';
import {useManifestationImportProps} from 'services/metadata';
import {getRestrictedManifestationCodelist} from '../functions/getRestrictedManifestationCodelist';
import {useMemoizedCodelistRestrictor} from './useMemoizedCodelistRestrictor';

export const useManifestationCodelistRestrictor = (
  manifestationId: string,
  expressionId: string,
): CodelistRestrictor => {
  const importProps = useManifestationImportProps(
    manifestationId,
    expressionId,
  );
  const {getRestrictedCodelist: getOuterRestrictedCodelist} =
    useRestrictedCodelistsContext();

  const restrict = useCallback<CodelistRestrictor>(
    codelist => {
      const outerCodelist = getOuterRestrictedCodelist(codelist);
      return getRestrictedManifestationCodelist(importProps, outerCodelist);
    },
    [getOuterRestrictedCodelist, importProps],
  );

  return useMemoizedCodelistRestrictor(restrict);
};
